module.exports = __webpack_public_path__ + "media/images/lb/454-7b0848005d7dda7f77a20eb9ca75e465.svg";